// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1f35C","left":"StickyBox_left__TYbhD","right":"StickyBox_right__3l59d"};